import { Component, OnInit, Renderer, Input, Output, EventEmitter } from '@angular/core';
import { ConsultantModel } from 'app/model/consultant.model';
import { ConsultService } from 'app/services/consult/consult.service';
import { FormStatus } from 'app/components/form-status/form-status.constants';
import { FormBaseComponent } from 'app/components/form/form-base.component';

@Component({
    selector: 'form-consultant',
    templateUrl: './form-consultant.component.html',
    styleUrls: ['./form-consultant.component.scss']
})
export class FormConsultantComponent extends FormBaseComponent implements OnInit {

    /** 整理番号 */
    @Input()
    referenceNum: string;
    
    /** ステータス */
    @Input()
    status: string;

    @Output()
    dataloaded = new EventEmitter();

    @Output()
    statuschange = new EventEmitter();

    isNew: boolean = true;
    isAllDone: boolean = false;


    /** collapseの展開情報を記録 */
    collapseInfo: ConsultantModel = new ConsultantModel();

    /** form 情報 */
    consultantInfo: ConsultantModel;
    

    /** 入力・表示モード */
    editable: boolean;
    confirmation: boolean;

    constructor(private consultService: ConsultService) {
        super();
    }


    /** 画面の初期処理 */
    async ngOnInit() {

        try {
            this.loading.emit(true);
            let res: ConsultantModel = await this.consultService.getConsultant(this.referenceNum);
            
            if (res) {
                this.consultantInfo = res;
                this.sycnCollapseInfo();
    
                this.isNew = false;
                this.dataloaded.emit('hasData');
    
                if (this.status == FormStatus.AllDone) {
                    this.isAllDone = true;
                }
    
            } else {
                
                this.consultantInfo = new ConsultantModel();
    
                this.isNew = true;
            }
            this.editable = true;
            this.confirmation = false;

        } catch(err) {
            this.alert('danger', err.message);
        } finally {
            this.loading.emit(false);
        }
    }

    /**
     * 内容が存在する項目は、展開する
     */
    sycnCollapseInfo() {
        Object.keys(this.consultantInfo).forEach(key => {
            if (this.consultantInfo[key] && this.consultantInfo[key].length > 0) {
                this.collapseInfo[key] = 'true';
            } else {
                this.collapseInfo[key] = null;
            }
        });
    }

    /**
     * 入力チェック処理
     */
    validateForm(form) {
        if (form.invalid)  {
            return;
        }

        this.sycnCollapseInfo();
        this.editable = false;
        this.confirmation = true;
    }

    /**
     * Form内容を更新する
     */
    async updateConsultant() {
        try {
            this.loading.emit(true);

            await this.consultService.updateConsultant(this.referenceNum, this.consultantInfo, this.isAllDone);
            
            this.editable = true;
            this.confirmation = false;
            this.isNew = false;

            // ステータスを通知
            if (this.isAllDone) {
                this.status = FormStatus.AllDone;
                this.statuschange.emit(FormStatus.AllDone);
            } else {
                this.status = FormStatus.ConfirmingFact;
                this.statuschange.emit(FormStatus.ConfirmingFact);
            }

            this.alert('success', '窓口作成調書を保存しました。', 7000);
            
        } catch(err) {
            this.alert('danger', err.message);
            console.error(err);

        } finally {
            this.loading.emit(false);
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/components/form-consultant/form-consultant.component.ts